import { computed, unref, type Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import Dialer from "@/services/dialer/dialer";
import type { DialerSessionDetail } from "@/dtos/Dialer.dto";

export function useDialerSessionDetail(id: Ref<string | null | undefined> | string | null) {
  return useQuery({
    queryKey: computed(() => ["dialerSession", "detail", unref(id) || "none"]),
    enabled: computed(() => !!unref(id)),
    queryFn: async (): Promise<DialerSessionDetail> => {
      const sessionId = unref(id) as string;
      const result = await Dialer.getSessionById(sessionId);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to load dialer session");
      }
      return result.data.data;
    },
  });
}
